import audio from '../../../../assets/audio/kids-tracks/Text23.mp3';

export const step32talk = {
    id: 32,
    title: 'Kostel',
    taskText: `
        <p>
            Tady je to ale pěkné a je tu tolik zajímavých věcí. Jak se tak ale koukám na střechy okolo sebe, 
            říkám si, jestli neměl upír Ulrich pravdu s tím, že by se to tu spíš mělo jmenovat Červená hora.
        </p>
        <p>
            Díky moc Lindo, kam ale teď?
        </p>
        <p>
            „Já bych šla tam, odkud jsme přišli, k tomu prasečímu ocásku. Tam je dobrý výhled široko daleko a můžeme se tam rozhodnout co dál.”
        </p>
    `,
    cipher: {
        text: `
            <p>
                Vyjděte ven kudy jste přišli a zastavte u stojanu na kola.
            </p>
        `,
        label: 'Úkol',
    },
    continueButtonText: 'Jsme tady',
    points: false,
    audio: audio,
};
